import "./chatUserInfo.scss";
import PropTypes from 'prop-types';
import "./chatUserInfo.scss";
//import pic from "../../../styles/images/pic-4.png";
import React from "react";
import { initialStateModel, LoginState } from "../../../../models/model";
import { useSelector } from "react-redux";
import singleIcon from "../../../../styles/images/Welaunch_Profile_Pic.svg";
import deleteIcon from "../../../../styles/images/delete_Pic.svg";


export default function ChatUserInfo(props: any) {
  let {tooltipTitle,userDetails, className, ...restProps } = props;
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const allContacs: any = useSelector((state: initialStateModel) => state.contactReducer);
  
  let deleteContact = allContacs?.deleteContacts;
  let delIcon:any = deleteContact[userDetails?.sip_login_id]; 

  let sip = userDetails?.caller_id===loginDetails.userdetails.caller_id? 2 :1;
  
  return (
    <>
      <div className={className} {...restProps}>
      {delIcon !== undefined?
      <div className={ `lefts colorBG${sip} ${userDetails?.profile_image_thumbnail?"proImg":""}` }>
      <img src={deleteIcon} alt=""></img>
     </div> :
      userDetails?.is_blocked === 1? 
       <div className={ `lefts colorBG${sip} ${userDetails?.profile_image_thumbnail?"proImg":""}` }>
         <img src={singleIcon} alt=""></img>
        </div> :
        <div className={ `lefts colorBG${sip} ${userDetails?.profile_image_thumbnail?"proImg":""}` }>
          {userDetails?.profile_image_thumbnail &&
           userDetails?.caller_id!==loginDetails.userdetails.caller_id?
            <img src={userDetails?.profile_image_thumbnail} alt=""></img>:
            loginDetails.userdetails.profile_image_thumbnail&&
             userDetails?.caller_id===loginDetails.userdetails.caller_id?
              <img src={loginDetails.userdetails.profile_image_thumbnail} alt=""></img>:
              <span>{userDetails==='Unknown User'?'Unknown'?.charAt(0).toUpperCase():
              userDetails?.first_name?.charAt(0) !== undefined?
              (userDetails?.first_name?.charAt(0).toUpperCase()+userDetails?.last_name?.charAt(0).toUpperCase()) : userDetails?.caller_id?.charAt(0).toUpperCase()}</span>}
        
        </div> }
{/*         
        {
          userDetails?.user_status ? (userDetails?.user_status === "Available" ?
            <span className="bgGreen statusRound"></span>
            : userDetails?.user_status && userDetails?.user_status === "Busy"
              ?
              <span className="bgYello statusRound"></span>
              :userDetails?.user_status && userDetails?.user_status === "Do not disturb"
                ?
                <span className="bgRed statusRound"></span>
                :
                <span className="bgGrey statusRound"></span>):
            (loginDetails?.userdetails?.user_status  === "Available" ?
                
              <span className="bgGreen statusRound"></span>:
              loginDetails?.userdetails?.user_status === "Busy"
                ?
                <span className="bgYello statusRound"></span>
                : loginDetails?.userdetails?.user_status === "Do not disturb"
                  ?
                  <span className="bgRed statusRound"></span>
                  :
                  <span className="bgGrey statusRound"></span>)


        } */}
       
       
        
       
      </div>
    </>
  );
};

ChatUserInfo.propTypes = {
  tooltipTitle: PropTypes.any,
  className: PropTypes.any,
  userDetails:PropTypes.any
};